import React, { FC } from 'react'
import { Flex } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import { EmptyState, Well } from '@pushly/aqe/lib/components'
import { VERTICAL_WELL_GAP } from '../../theme/constants'
import { getClassNames } from '../../_utils/classnames'

interface IPageAnalysisSettings {
    loading: boolean
}

/**
 * Placeholder for the Page Analysis service, which is built on its own branch.
 *
 * It holds the rail entry and the `#ai/page-analysis` route so landing here is not a dead end.
 * The real view replaces this file; its props (`loading`, `domain`) are what the AI section passes.
 */
export const PageAnalysisSettings: FC<IPageAnalysisSettings & { domain?: unknown }> = () => (
    <Flex vertical gap={VERTICAL_WELL_GAP} className={getClassNames('page-analysis-settings')}>
        <Well title="Page Analysis" footerMode="hidden">
            <EmptyState icon={<EditOutlined />} iconVariant="chip" title="Not available here yet" />
        </Well>
    </Flex>
)
